import React from "react";
import { Star, MapPin } from "lucide-react";

export const ReportReviews = ({ reviewsData, brandInput }) => {
  const companyReviews = reviewsData?.company;
  const competitorReviews = reviewsData?.competitors || [];

  return (
    <div className="space-y-6">
      {companyReviews && (
        <div className="bg-gradient-to-br from-emerald-900/30 to-slate-900 border border-emerald-500/30 rounded-2xl p-6">
          <h3 className="font-semibold text-emerald-400 mb-4 flex items-center gap-2">
            <MapPin className="w-5 h-5" /> Your Business
          </h3>
          <div className="flex items-center gap-6 mb-4">
            <div>
              <p className="text-4xl font-bold text-white flex items-center gap-2">
                {companyReviews.rating || "N/A"}
                <Star className="w-8 h-8 fill-yellow-400 text-yellow-400" />
              </p>
              <p className="text-slate-400 text-sm">{companyReviews.reviews_count || 0} reviews</p>
            </div>
            {companyReviews.sentiment && (
              <div className="flex gap-4">
                <div className="text-center">
                  <p className="text-2xl font-bold text-emerald-400">{companyReviews.sentiment.positive}%</p>
                  <p className="text-slate-500 text-xs">Positive</p>
                </div>
                <div className="text-center">
                  <p className="text-2xl font-bold text-yellow-400">{companyReviews.sentiment.neutral}%</p>
                  <p className="text-slate-500 text-xs">Neutral</p>
                </div>
                <div className="text-center">
                  <p className="text-2xl font-bold text-red-400">{companyReviews.sentiment.negative}%</p>
                  <p className="text-slate-500 text-xs">Negative</p>
                </div>
              </div>
            )}
          </div>
          {companyReviews.address && (
            <p className="text-slate-400 text-sm">{companyReviews.address}</p>
          )}
        </div>
      )}
      {competitorReviews.length > 0 && (
        <div className="bg-slate-900/50 border border-slate-800 rounded-2xl p-6">
          <h3 className="font-semibold text-white mb-6">Competitor Reviews Comparison</h3>
          <div className="space-y-4">
            {competitorReviews.map((comp) => (
              <div key={`review-${comp.name}`} className="flex items-center justify-between p-4 bg-slate-800/50 rounded-xl">
                <div className="flex-1">
                  <p className="font-medium text-white">{comp.name}</p>
                  {comp.address && comp.address !== "Not found on Google Maps" && (
                    <p className="text-slate-500 text-xs">{comp.address}</p>
                  )}
                </div>
                <div className="flex items-center gap-6">
                  <div className="text-center">
                    <p className="text-xl font-bold text-white flex items-center gap-1">
                      {comp.rating || "N/A"}
                      <Star className="w-4 h-4 fill-yellow-400 text-yellow-400" />
                    </p>
                    <p className="text-slate-500 text-xs">{comp.reviews_count || 0} reviews</p>
                  </div>
                  {comp.sentiment && comp.sentiment.positive > 0 && (
                    <div className="w-24 bg-slate-700 rounded-full h-2 overflow-hidden">
                      <div className="bg-emerald-500 h-full" style={{ width: `${comp.sentiment.positive}%` }} />
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
      {!companyReviews && competitorReviews.length === 0 && (
        <div className="bg-slate-900/50 border border-slate-800 rounded-2xl p-8 text-center">
          <Star className="w-12 h-12 text-slate-600 mx-auto mb-4" />
          <p className="text-slate-400">
            No Google Reviews data available. Add a location to your business details to enable this feature.
          </p>
        </div>
      )}
    </div>
  );
};
